export default "__VITE_PUBLIC_ASSET__cb91eb02__"